/* eslint-disable */

import type { InvoicesLang } from "./types/InvoicesLang";

let data: InvoicesLang | undefined;

export type { InvoicesLang };

export default function InvoicesLangFactory(): InvoicesLang {
  if (!data) {
    throw new Error("Trying to load a language in the main bundle before the language bundle is loaded");
  }
  return data;
}

export let setInvoicesLang = (newLang: string) => {
  if (newLang === "en-GB") {
      return import(/* webpackChunkName: "en-GB.locale" */ "./en-GB/InvoicesLangDef").then(({ InvoicesLangDef }) => {
      data = InvoicesLangDef;
    });
  } else if (newLang === "sv-SE") {
      return import(/* webpackChunkName: "sv-SE.locale" */ "./sv-SE/InvoicesLangDef").then(({ InvoicesLangDef }) => {
      data = InvoicesLangDef;
    });
  } else if (newLang === "en-SE") {
      return import(/* webpackChunkName: "en-SE.locale" */ "./en-SE/InvoicesLangDef").then(({ InvoicesLangDef }) => {
      data = InvoicesLangDef;
    });
  } else if (newLang === "ky-KG") {
      return import(/* webpackChunkName: "ky-KG.locale" */ "./ky-KG/InvoicesLangDef").then(({ InvoicesLangDef }) => {
      data = InvoicesLangDef;
    });
  }
  else {
    throw new Error("Unsupported language/culture " + newLang);
  }
};

